import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

import { type ExperimentNames } from './experiment-keys';

type AssurePrimitives<T> = T extends string ? string : T extends number ? number : T extends boolean ? boolean : T;

export function expVal<T>(experimentName: ExperimentNames, param: string, defaultValue: T): AssurePrimitives<T> {
	const value = FeatureGates.getExperimentValue(experimentName, param, defaultValue);

	return value as AssurePrimitives<T>;
}

/**
 * Same as expVal but does not fire experiment exposure event.
 *
 * @deprecated Please use expVal instead. Using this function may cause exposure events to be missed, resulting in lower quality experiment data.
 */
export function expValWithoutExposure<T>(
	experimentName: ExperimentNames,
	param: string,
	defaultValue: T,
): AssurePrimitives<T> {
	const value = FeatureGates.getExperimentValue(experimentName, param, defaultValue, {
		fireExperimentExposure: false,
	});

	return value as AssurePrimitives<T>;
}

export function manuallyFireExperimentExposure(experimentName: ExperimentNames): void {
	FeatureGates.manuallyLogExperimentExposure(experimentName);
}
